var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"px-1"},_vm._l((_vm.routes),function(ref){
var link = ref.link;
var name = ref.name;
var iconSrc = ref.iconSrc;
return _c('b-col',{key:link,staticStyle:{"padding-left":"0.5rem","padding-right":"0.5rem"},attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('LinkCard',{attrs:{"to":link,"name":name,"icon":iconSrc}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }